import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { controlSurface } from './control-styles';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      controlSurface,
      'flex min-h-[80px] resize-y px-3 py-2 leading-relaxed',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
